export function waitWith<T extends any>(executor: (resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void) {
  return new Promise<T>(executor);
}